'use strict'

import { Enum } from './enums'

const LanguageEnum = new Enum({
  CHINESE: { value: 1, text: '中文' },
  ENGLISH: { value: 2, text: 'English' }
})

export { LanguageEnum }



// WEBPACK FOOTER //
// ./src/utils/LanguageEnum.js